import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters, {
	type standardToPremiumModalQuery,
} from './__generated__/standardToPremiumModalQuery.graphql';

type EntryPointParams = {
	cloudId: string;
	hamsProductKey: string;
};

type StandardToPremiumModalComponent = EntryPointComponent<
	{
		standardToPremiumModalQuery: standardToPremiumModalQuery;
	},
	Record<string, never>,
	{
		onClose: () => void;
	},
	Record<string, never>
>;

export const entryPoint: EntryPoint<StandardToPremiumModalComponent, EntryPointParams> =
	createEntryPoint({
		root: JSResourceForInteraction<StandardToPremiumModalComponent>(
			/* webpackChunkName: "@atlaskit-internal_edition-awareness-standard-to-premium-modal" */ './standard-to-premium-modal',
			{
				moduleId: 'edition-awareness-standard-to-premium-modal',
			},
		),
		getPreloadProps: ({ cloudId, hamsProductKey }: EntryPointParams) => ({
			entryPoints: {},
			extraProps: {},
			queries: {
				standardToPremiumModalQuery: {
					parameters,
					variables: {
						cloudId,
						hamsProductKey,
					},
				},
			},
		}),
	});
